import { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { assessmentReportHeader } from "../components/HeaderAttribute";
import { BindAPI } from "../services/APIConnection";

const AssessmentReport = () => {
  const [assessmentReportDatas, setAssessmentReportDatas] = useState([]);
  const [showFileModal, setShowFileModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFileUrl, setSelectedFileUrl] = useState("");
  useEffect(() => {
    FetchDatas();
  }, []);

  const FetchDatas = async () => {
    setIsLoading(true);
    const response = await BindAPI("ReportAPI/ReportAssessmentReport");
    setAssessmentReportDatas(response.data.Table);
    setIsLoading(false);
  };
  const isImageFile = (url) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
    const ext = url?.split(".").pop()?.toLowerCase();
    return imageExtensions.includes(ext);
  };
  const getViewerUrl = (url) => {
    if (!url) return "";
    const extension = url.split(".").pop().toLowerCase();

    return extension === "pdf"
      ? url
      : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
          url
        )}`;
  };
  const handleView = (rowIndex) => {
    var AttachmentFile = assessmentReportDatas[rowIndex].AttachmentFile;
    setSelectedFileUrl(AttachmentFile);
    setShowFileModal(true);
  };
  return (
    <MainLayout pageName={"2"}>
      <div>
        {!isLoading && (
          <GridPage
            title="Assessment Report"
            header={assessmentReportHeader}
            records={assessmentReportDatas}
            blockView={false}
            addView={true}
            handleSchoolView={handleView}
          />
        )}
      </div>{" "}
      {showFileModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowFileModal(false)} // Outside click closes modal
        >
          <div
            className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
            onClick={(e) => e.stopPropagation()} // Prevent close on inside click
          >
            <button
              onClick={() => setShowFileModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>
            {selectedFileUrl ? (
              isImageFile(selectedFileUrl) ? (
                <img
                  src={selectedFileUrl}
                  alt="Preview"
                  className="w-full h-full object-contain rounded"
                />
              ) : (
                <iframe
                  src={getViewerUrl(selectedFileUrl)}
                  title="File Viewer"
                  className="w-full h-[80vh] rounded"
                />
              )
            ) : (
              <div className="text-center text-gray-500">No file selected</div>
            )}
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default AssessmentReport;
